import React from "react";
import { View, Text, Image, StyleSheet, TouchableOpacity } from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useSelector } from "react-redux";
import { Avatar } from "react-native-paper";
import * as Okta from "../../services/oktaAuthService";
import oktaConfig from "../../configs/okta";
import { clearSessionStorage } from "../../services/utils/storageService";
import { persistor } from "../../redux/configureStore";

export default function MobileSettingsScreen({ navigation }: any) {
  const { userInfo, profilePhoto, isDrawer, hasAvatar, currentRole } =
    useSelector((state: any) => state.configurations);

  const fullName: string[] = userInfo?.display_name?.split(" ") ?? [];
  const initial = fullName.length > 0 ? fullName[0].charAt(0) : "U";

  const { loading, notificationCount } = useSelector(
    (state: any) => state.notification
  );

  const logoutHandler = () => {
    Okta.deleteSession().then(() => {
      clearSessionStorage();
      window.location.href = `${oktaConfig.api.redirectUri}`;
    });
    persistor.purge();
  };

  return (
    <View style={styles.container}>
      <View style={{ flex: 1 }}>
        <View style={[styles.user, styles.row]}>
          <View style={styles.imgIconContainer}>
            {hasAvatar ? (
              <Avatar.Image
                size={isDrawer ? 55 : 35}
                source={profilePhoto}
                style={{ backgroundColor: "white" }}
              />
            ) : (
              <Avatar.Text
                size={isDrawer ? 55 : 35}
                label={initial}
                style={{ backgroundColor: "#3d4db7" }}
              />
            )}
          </View>
          <View style={styles.justifyContent}>
            <Text style={styles.userName}>{userInfo?.display_name}</Text>
          </View>
        </View>

        <View style={styles.row}>
          <View style={styles.imgIconContainer}>
            <FontAwesome name="user" size={24} color="black" />
          </View>
          <View style={styles.justifyContent}>
            <TouchableOpacity
              onPress={() =>
                navigation.navigate("UserSettings", { screen: "Profile" })
              }
            >
              <Text style={styles.rowTitle}>Account Settings</Text>
            </TouchableOpacity>
          </View>
        </View>

        {["OWNER", "ADMIN"].includes(currentRole) && (
          <View style={styles.row}>
            <View style={styles.imgIconContainer}>
              <FontAwesome name="users" size={24} color="black" />
            </View>
            <View style={styles.justifyContent}>
              <TouchableOpacity
                onPress={() =>
                  navigation.navigate("OrgSettings", { screen: "Users" })
                }
              >
                <Text style={styles.rowTitle}>User Management</Text>
              </TouchableOpacity>
            </View>
          </View>
        )}

        {["OWNER", "ADMIN"].includes(currentRole) && (
          <View style={styles.row}>
            <View style={styles.imgIconContainer}>
              <FontAwesome name="building" size={24} color="black" />
            </View>
            <View style={styles.justifyContent}>
              <TouchableOpacity
                onPress={() =>
                  navigation.navigate("OrgSettings", { screen: "Company" })
                }
              >
                <Text style={styles.rowTitle}>Organization Settings</Text>
              </TouchableOpacity>
            </View>
          </View>
        )}

        <View style={styles.row}>
          <View style={styles.imgIconContainer}>
            <MaterialCommunityIcons name="bell-alert" size={24} color="black" />
            {!loading && notificationCount > 0 && (
              <View style={{ position: "relative", marginTop: -30 }}>
                <View style={styles.badge}>
                  <Text style={styles.badgeText}>{notificationCount}</Text>
                </View>
              </View>
            )}
          </View>
          <View style={styles.justifyContent}>
            <TouchableOpacity
              onPress={() =>
                navigation.navigate("UserSettings", {
                  screen: "Notification",
                })
              }
            >
              <Text style={styles.rowTitle}>Notifications</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View>
        <View style={styles.row}>
          <View style={[styles.imgIconContainer, { paddingRight: 0 }]}>
            <MaterialCommunityIcons name="logout" size={24} color="red" />
          </View>
          <View style={styles.justifyContent}>
            <TouchableOpacity onPress={() => logoutHandler()}>
              <Text style={styles.logoutTitle}>Sign Out</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  justifyContent: { justifyContent: "center" },
  container: { flex: 1, backgroundColor: "#fff" },
  row: { flexDirection: "row", paddingHorizontal: 12, paddingVertical: 15 },
  user: { borderBottomWidth: 1, borderBottomColor: "#F0F0F0" },
  userImg: { width: 28, height: 28, backgroundColor: "grey", borderRadius: 50 },
  userName: { fontWeight: "800" },
  rowTitle: { fontWeight: "500" },
  imgIconContainer: { paddingRight: 10, width: 35, alignItems: "center" },
  logoutTitle: { fontWeight: "500", fontSize: 16, color: "red" },
  badge: {
    position: "absolute",
    top: -4,
    right: -4,
    backgroundColor: "red",
    borderRadius: 10,
    paddingHorizontal: 5,
    minWidth: 18,
    height: 18,
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
  badgeText: {
    color: "white",
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
  },
});
